import React from 'react';

import {
  Text,
  TestimonyNew,
} from './styles';


export default () => {
  return (
    <TestimonyNew>
      <Text>
        To create your <b>player account</b>, download the app from the App Store or Google Play, then select ‘Create Account’ on the login screen.
      </Text>
    </TestimonyNew>
  )
};
